export default __webpack_public_path__ + "49e730e61305c12664ba071bab1f84a7.png";